import React, { FC, useState } from 'react';
import BlockTypeUsageAnalyzer from '@/components/Admin/AdminAnalysisAndStatistics/AdminBlockTypeUsageAnalyzer/BlockTypeUsageAnalyzer';
import { Tab, Tabs, Typography } from '@mui/material';
import Container from '@/components/Container';

export const AdminAnalysisAndStatisticsView: FC = () => {
  const [useTab, setUseTab] = useState(0);

  return (
    <Container left fullWidth p={2} gap={2} top mt={0} column>
      <Typography variant='h3' sx={{ fontSize: 30 }}>
        Analyser og statistikk
      </Typography>
      <Tabs
        value={useTab}
        onChange={(_, newValue) => setUseTab(newValue)}
        textColor='secondary'
        slotProps={{
          indicator: {
            style: {
              background: 'black',
            },
          },
        }}
        sx={{ mb: 2 }}>
        <Tab label='Hvilke sider bruker hvilke moduler' value={0} />
        <Tab label='Andre analyser' value={1} />
      </Tabs>
      {useTab === 0 && <BlockTypeUsageAnalyzer />}
      {useTab === 1 && <Typography>Kommer mer</Typography>}
    </Container>
  );
};

export default AdminAnalysisAndStatisticsView;
